import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useOccupationCategoriesUIContext } from "../OccupationCategoriesUIContext";

const prepareFilter = (queryParams, values) => {
  const { category } = values;
  const newQueryParams = { ...queryParams };
  const filter = { category };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function OccupationCategoriesFilter() {
  // Occupation Categories UI Context
  const categoriesUIContext = useOccupationCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      setQueryParams: categoriesUIContext.setQueryParams,
      queryParams: categoriesUIContext.queryParams,
    };
  }, [categoriesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(categoriesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, categoriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      categoriesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        category: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="category"
                placeholder="Kategori"
                onBlur={handleBlur}
                value={values.category}
                onChange={(e) => {
                  setFieldValue("category", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kategori</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}